<template>
    <div>
        <div class="form-group">
            <label for="url">
                <span v-tooltip="'If domain is not presented it will use this app api'" class="text-muted">
                    <i class="fal fa-info-circle"></i>
                </span>
                URL
            </label>
            <input type="text"
                   :value="api.url"
                   @change="e => updateApiConfig({path: 'url', data: e.target.value})"
                   id="url"
                   class="form-control form-control-sm">
        </div>
        <div class="form-group">
            <AppRadioButtonsGroup
                label="label"
                trackBy="name"
                :value="api.method"
                :options="[{name: 'GET', label: 'GET'}, {name: 'POST', label: 'POST'}]"
                @update="v => updateApiConfig({path: 'method', data: v})"/>
        </div>

        <template v-for="grid in [headersGrid, parametersGrid]">
            <div @click="grid.expand = !grid.expand" class="clickable text-bold my-2">
                {{ grid.label }}
                <AppExpandChevron :show="grid.expand" class="pl-1"/>
            </div>
            <template v-if="grid.expand">
                <ag-grid-vue
                    class="ag-theme-balham config-table"
                    :columnDefs="gridConfig.columnDefs"
                    :defaultColDef="gridConfig.defaultColDef"
                    :rowData="grid.rowsData"
                    rowSelection="multiple"
                    @selection-changed="onChangeSelection(grid)"
                    @grid-ready="params => onGridReady({grid, params})"
                    @cell-value-changed="event => onCellValueChanged({grid, event})">
                </ag-grid-vue>
                <div class="row py-2">
                    <div @click="addRow(grid)" class="col-4 text-purple clickable">
                        Add
                    </div>
                    <div v-if="grid.selectedRows && grid.selectedRows.length !== 0"
                         @click="removeSelectedRow(grid)"
                         class="col-8 text-danger clickable text-right">
                        Remove selected
                    </div>
                </div>
            </template>
        </template>

        <slot name="footer"></slot>

    </div>
</template>

<script>
import AppRadioButtonsGroup from '../../../../../../../../components/shared/AppRadioButtonsGroup'
import AppExpandChevron from '../../../../../../../../components/shared/AppExpandChevron'

export default {
    name: 'FieldOptionsApiConfig',
    components: {AppExpandChevron, AppRadioButtonsGroup},
    props: {
        api: {
            type: Object,
            required: true,
            default: () => ({})
        }
    },
    data() {
        return {
            headersGrid: {
                key: 'headers',
                label: 'Headers',
                expand: false,
                gridApi: null,
                columnApi: null,
                rowsData: [],
                selectedRows: []
            },

            parametersGrid: {
                key: 'params',
                label: 'Parameters',
                expand: false,
                gridApi: null,
                columnApi: null,
                rowsData: [],
                selectedRows: []
            },

            gridConfig: {
                columnDefs: [{
                    headerName: 'Key',
                    field: 'key',
                    tooltipField: 'key',
                    tooltipValueGetter: ({value}) => value
                }, {
                    headerName: 'Value',
                    field: 'value',
                    tooltipField: 'value',
                    tooltipValueGetter: ({value}) => value
                }],
                defaultColDef: {
                    flex: 1,
                    editable: true,
                    sortable: true,
                    resizable: true
                }
            }
        }
    },
    methods: {
        updateApiConfig({path, data}) {
            this.$emit('update', {path, data})
        },

        onGridReady({grid, params}) {
            grid.gridApi = params.api
            grid.columnApi = params.columnApi
            if (_.isPlainObject(this.api[grid.key])) {
                const rows = Object
                    .keys(this.api[grid.key])
                    .map(key => ({key, value: this.api[grid.key][key]}))
                if (rows.length !== 0) {
                    grid.gridApi.applyTransaction({add: rows})
                } else {
                    grid.gridApi.applyTransaction({add: [{key: '', value: ''}]})
                }
            }
        },

        onCellValueChanged({grid, event}) {
            this.updateGridData(grid)
        },

        updateGridData(grid) {
            const data = {}
            this.getRowsData(grid).forEach(({key, value}) => {
                data[key] = value
            })
            this.updateApiConfig({path: grid.key, data})
        },

        getRowsData(grid) {
            const rowsData = []
            grid.gridApi.forEachNode(function(node) {
                rowsData.push(node.data)
            })
            return rowsData
        },

        onChangeSelection(grid) {
            grid.selectedRows = grid.gridApi.getSelectedRows()
        },

        addRow(grid) {
            grid.gridApi.showLoadingOverlay()
            const newRow = {}
            this.gridConfig.columnDefs.forEach(c => {
                newRow[c.field] = ''
            })
            grid.gridApi.applyTransaction({add: [newRow]})
            grid.gridApi.hideOverlay()
        },

        removeSelectedRow(grid) {
            grid.gridApi.showLoadingOverlay()
            grid.gridApi.applyTransaction({remove: grid.selectedRows})
            this.updateGridData(grid)
            grid.gridApi.hideOverlay()
        }
    },
    created() {
        if (_.isPlainObject(this.api.params) && Object.keys(this.api.params).length !== 0) {
            this.parametersGrid.expand = true
        }
        if (_.isPlainObject(this.api.headers) && Object.keys(this.api.headers).length !== 0) {
            this.headersGrid.expand = true
        }
    }
}
</script>

<style lang="scss" scoped>
    .config-table {
        height: 150px;
    }
</style>
